import {
  Outlet, useOutletContext,
  useParams,
} from 'react-router-dom';
import { RoutingContextType } from '.';
import { AuditProvider } from '../contexts/audit';

export function AuditRoutes() {
  const outletValue: RoutingContextType = useOutletContext();

  const { id } = useParams() as {id: string};

  const contextValue: RoutingContextType = {
    ...outletValue,
  };

  return (
    <AuditProvider id={id}>
      <Outlet context={contextValue} />
    </AuditProvider>
  );
}
